var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconButtonLoadingRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 2C29.9412 2 38 10.0589 38 20C38 29.9412 29.9412 38 20 38C10.0589 38 2 29.9412 2 20C2 10.0589 10.0589 2 20 2Z",
    stroke: "#cf7171",
    strokeOpacity: 0.5,
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 2C29.9412 2 38 10.0589 38 20",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconButtonLoadingRed);
export default __webpack_public_path__ + "static/media/icon-ButtonLoading-red.16934cd54cc5d658dd5d664c29d315f8.svg";
export { ForwardRef as ReactComponent };